export default __webpack_public_path__ + "images/multiply-airline.f909539.png";